import { useState, useEffect } from "react"
import ReloadIcon from "../images/ReloadIcon";
import { handleFirstQRcode, handleSecondQRcode, handleCheckStatusQrcode } from "../../../services/chatService";
import { useDispatch } from "react-redux";

const QrcodeMessage = ({url, timeoutMs}) => {

	const dispatch = useDispatch();
	const [remainingTime, setRemainingTime] = useState(timeoutMs)

	const startTimer = () => {
		setRemainingTime(timeoutMs);
		const interval = setInterval(() => {
			setRemainingTime((prev) => {
				if (prev <= 1000) {
					clearInterval(interval);
					return 0;
				}
				return prev - 1000;
			});
		}, 1000);
		return interval;
	};
	

	useEffect(() => {
    if (!url) return; 
    const interval = startTimer()
    return () => clearInterval(interval);
  }, [url, timeoutMs]);

  const expired = remainingTime <= 0;

  // format mm:ss
  const minutes = Math.floor(remainingTime / 1000 / 60);
  const seconds = Math.floor((remainingTime / 1000) % 60)
    .toString()
    .padStart(2, "0");

	const handleReloadQRcode = async () => {
		try {
			const interval = startTimer(); 
			await handleFirstQRcode(dispatch);
			await Promise.all([
				handleSecondQRcode(dispatch),
				handleCheckStatusQrcode(dispatch),
			]);
			dispatch(setQrcodeUrl(null))
			return () => clearInterval(interval);
		} catch (error) {
			console.error("Self-service flow error:", error.message);
		}
	}

  return (
    <>
			<div className={`qrcode-image`}>
				<img className="content-rounded" src={url} alt="qrcode"/>
				{expired && <div className="qrcode-reload"><div className="div-click" onClick={() => handleReloadQRcode()}><ReloadIcon/></div></div>}
			</div>
			{!expired ? (
        <>
          <p style={{ textAlign: "center", fontSize: "12px"}}>
            Please scan using <br></br><b>HLB Connect app</b>
          </p>
          <p style={{ textAlign: "center", fontSize: "12px", color: "#666" }}>
            Expires in {minutes}:{seconds}
          </p>
        </>
      ) : (
				<div style={{display:"flex", justifyContent:"center", alignItems: 'center', flexDirection: 'column'}}>
					<p style={{ textAlign: "center", fontSize: "12px", color: "red" }}>
						QR code expired
					</p>
				</div>
      )}
		</>
  )
}

export default QrcodeMessage